module.exports = __webpack_public_path__ + "img/play.3f9ed6a0.svg";